import { axiosInstance, parseResult } from "./CommonApi";

//화재수신기 목록 조회
export const getFireReceiverManageList = async (
  status,
  searchType,
  search,
  page,
  pageSize
) => {
  const params = new URLSearchParams();
  params.append("status", status);
  params.append("searchType", searchType);
  if (search) {
    params.append("search", search);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(
    `/dbms_main/firereceiver-manage/list/`,
    { params }
  );
  return parseResult(response);
};

export const getFireReceiverManageListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//화재수신기 수정
export const updateFireReceiverManage = async (
  id,
  validBeginDt,
  validEndDt,
  suspBeginDt,
  suspEndDt,
  status
) => {
  const params = {
    id: id,
    validBeginDt: validBeginDt,
    validEndDt: validEndDt,
    suspBeginDt: suspBeginDt,
    suspEndDt: suspEndDt,
    status: status,
  };
  const response = await axiosInstance.put(
    `/dbms_main/firereceiver-manage/update/${id}/`,
    {},
    { params }
  );
  return parseResult(response);
};

//여러 화재수신기 삭제
export const deleteFireReceiverManage = async (requestBody) => {
  const response = await axiosInstance.delete(
    `/dbms_main/firereceiver-manage/delete/`,
    {
      data: requestBody,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//화재수신기 설정 목록 조회
export const getFireReceiverSettingList = async (
  searchType,
  search,
  page,
  pageSize
) => {
  const params = new URLSearchParams();
  params.append("searchType", searchType);
  if (search) {
    params.append("search", search);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(
    `/dbms_main/firereceiver-setting/list/`,
    { params }
  );
  return parseResult(response);
};

export const getFireReceiverSettingListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//화재수신기 설정 수정
export const updateFireReceiverSetting = async (
  id,
  reportCycle,
  fwDlUrl,
  reset
) => {
  const params = new URLSearchParams();
  params.append("id", id);
  if (reportCycle) {
    params.append("reportCycle", reportCycle);
  }
  if (fwDlUrl) {
    params.append("fwDlUrl", fwDlUrl);
  }
  if (reset) {
    params.append("reset", reset);
  }

  const response = await axiosInstance.put(
    `/dbms_main/firereceiver-setting/update/${id}/`,
    {},
    { params }
  );
  return parseResult(response);
};

//상태 Status 수신 로그 목록 조회
export const getStatusReceiveLogList = async (search, page, pageSize) => {
  const params = new URLSearchParams();
  if (search) {
    params.append("search", search);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(
    `/dbms_main/status-receive-log/list/`,
    { params }
  );
  return parseResult(response);
};

export const getStatusReceiveLogListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//제어 Data 전송 로그 목록 조회
export const getControlSendLogList = async (search, page, pageSize) => {
  const params = new URLSearchParams();
  if (search) {
    params.append("search", search);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(
    `/dbms_main/control-send-log/list/`,
    { params }
  );
  return parseResult(response);
};

export const getControlSendLogListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//사업자 목록 조회
export const getBusinessList = async (search, page, pageSize) => {
  const params = new URLSearchParams();
  if (search) {
    params.append("search", search);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(`/dbms_main/business/list/`, {
    params,
  });
  return parseResult(response);
};

export const getBusinessListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//사업자 추가
export const addBusiness = async (requestBody) => {
  const response = await axiosInstance.post(
    `/dbms_main/business/add/`,
    requestBody,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//사업자 수정
export const updateBusiness = async (id, requestBody) => {
  const params = { id: id };
  const response = await axiosInstance.post(
    `/dbms_main/business/update/${id}/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//사업자 삭제
export const deleteBusiness = async (id) => {
  const response = await axiosInstance.delete(
    `/dbms_main/business/delete/${id}/`,
    {}
  );
  return parseResult(response);
};

//여러 사업자 삭제
export const bulkDeleteBusiness = async (requestBody) => {
  const response = await axiosInstance.post(
    `/dbms_main/business/bulk-delete/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//사업자 사용중지
export const deactivateBusiness = async (id) => {
  const params = { id: id };
  const response = await axiosInstance.put(
    `/dbms_main/business/deactivate/${id}/`,
    {},
    { params }
  );
  return parseResult(response);
};

//여러 사업자 사용중지
export const bulkDeactivateBusiness = async (requestBody) => {
  const response = await axiosInstance.put(
    `/dbms_main/business/bulk-deactivate/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//사업자 목록 조회
export const getBusinessUserList = async (
  status,
  searchType,
  search,
  page,
  pageSize
) => {
  const params = new URLSearchParams();
  params.append("status", status);
  params.append("searchType", searchType);
  if (search) {
    params.append("search", search);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(`/dbms_main/business-user/list/`, {
    params,
  });
  return parseResult(response);
};

export const getBusinessUserListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//여러 사업자 상태 변경
export const updateBusinessUserStatus = async (status, requestBody) => {
  const params = { status: status };
  const response = await axiosInstance.put(
    `/dbms_main/business-user/change-status/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//여러 사업자 삭제
export const bulkDeleteBusinessUser = async (requestBody) => {
  const response = await axiosInstance.post(
    `/dbms_main/business-user/bulk-delete/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//사업자 목록 엑셀 다운로드
export const downloadExcelBusinessUserList = async (
  status,
  searchType,
  search
) => {
  const params = new URLSearchParams();
  params.append("status", status);
  params.append("searchType", searchType);
  if (search) {
    params.append("search", search);
  }
  const response = await axiosInstance.get(
    `/dbms_main/business-user/download/`,
    {
      params: params,
      responseType: "blob",
    }
  );

  return getDownloadExcelResult(response);
};

//일반 사용자 목록 조회
export const getGeneralUserList = async (
  status,
  searchType,
  search,
  page,
  pageSize
) => {
  const params = new URLSearchParams();
  params.append("status", status);
  params.append("searchType", searchType);
  if (search) {
    params.append("search", search);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(`/dbms_main/general-user/list/`, {
    params,
  });
  return parseResult(response);
};

export const getGeneralUserListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//여러 사용자 상태 변경
export const updateGeneralUserStatus = async (status, requestBody) => {
  const params = { status: status };
  const response = await axiosInstance.put(
    `/dbms_main/general-user/change-status/`,
    requestBody,
    {
      params: params,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//일반 사용자 목록 엑셀 다운로드
export const downloadExcelGeneralUserList = async (
  status,
  searchType,
  search
) => {
  const params = new URLSearchParams();
  params.append("status", status);
  params.append("searchType", searchType);
  if (search) {
    params.append("search", search);
  }
  const response = await axiosInstance.get(
    `/dbms_main/general-user/download/`,
    {
      params: params,
      responseType: "blob",
    }
  );

  return getDownloadExcelResult(response);
};

//일반 사용자 다중 삭제
export const bulkDeleteGeneralUser = async (requestBody) => {
  const response = await axiosInstance.post(
    `/dbms_main/general-user/bulk-delete/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//소방대상물 목록 조회
export const getFireFightingObjectList = async (
  buildingName,
  page,
  pageSize
) => {
  const params = new URLSearchParams();
  if (buildingName) {
    params.append("buildingName", buildingName);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(
    `/dbms_main/firefighting-object/list/`,
    { params }
  );
  return parseResult(response);
};

export const getFireFightingObjectListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//소방대상물 목록 엑셀 다운로드
export const downloadExcelFireFightingObjectList = async (buildingName) => {
  const params = new URLSearchParams();
  if (buildingName) {
    params.append("buildingName", buildingName);
  }
  const response = await axiosInstance.get(
    `/dbms_main/firefighting-object/download/`,
    {
      params: params,
      responseType: "blob",
    }
  );

  return getDownloadExcelResult(response);
};

//소방대상물 다중 삭제
export const bulkDeleteFireFightingObject = async (requestBody) => {
  const response = await axiosInstance.post(
    `/dbms_main/firefighting-object/bulk-delete/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//공지사항 목록 조회
export const getNoticePostList = async (page, pageSize) => {
  const params = new URLSearchParams();
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(`/dbms_main/notice-post/list/`, {
    params,
  });
  return parseResult(response);
};

export const getNoticePostListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//공지사항 등록
export const addNoticePost = async (requestBody) => {
  const response = await axiosInstance.post(
    `/dbms_main/notice-post/add/`,
    requestBody,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//공지사항 삭제
export const deleteNoticePost = async (id) => {
  const response = await axiosInstance.delete(
    `/dbms_main/notice-post/delete/${id}/`,
    {}
  );
  return parseResult(response);
};

//여러 공지사항 삭제
export const bulkDeleteNoticePost = async (requestBody) => {
  const response = await axiosInstance.post(
    `/dbms_main/notice-post/bulk-delete/`,
    requestBody,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

//시스템 모니터링 통계
export const getSystemMonitoringList = async () => {
  const response = await axiosInstance.get(
    `/dbms_main/system-monitoring/list/`
  );
  return parseResult(response);
};

//소방설비 MDB 목록 조회
export const getFireFightingMdbList = async () => {
  const response = await axiosInstance.get(`/dbms_main/firefighting-mdb/list/`);
  return parseResult(response);
};

//소방설비 MDB 추가
export const addFireFightingMdb = async (requestBody) => {
  const response = await axiosInstance.post(
    `/dbms_main/firefighting-mdb/add/`,
    requestBody,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//소방설비 MDB 삭제
export const bulkDeleteFireFightingMdb = async (requestBody) => {
  const response = await axiosInstance.delete(
    `/dbms_main/firefighting-mdb/bulk-delete/`,
    {
      data: requestBody,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};

export const getDownloadExcelResult = (response) => {
  const result = parseResult(response);
  const { status, data } = result;
  if (status === true) {
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: response.headers["content-type"] })
    );
    const filename =
      response.headers["content-disposition"]?.split("filename=")[1];

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  return result;
};

//화재수신기 MDB 목록 조회
export const getFireReceiverMdbList = async (
  search,
  filterType,
  page,
  pageSize
) => {
  const params = new URLSearchParams();
  if (search) {
    params.append("search", search);
  }
  if (filterType) {
    params.append("filterType", filterType);
  }
  if (page) {
    params.append("page", page);
  }
  if (pageSize) {
    params.append("page_size", pageSize);
  }

  const response = await axiosInstance.get(
    `/dbms_main/fire-receiver-mdb/list/`,
    { params }
  );
  return parseResult(response);
};

export const getFireReceiverMdbListByUrl = async (url) => {
  const response = await axiosInstance.get(url);
  return parseResult(response);
};

//화재수신기 MDB 엑셀 유효성 검사
export const validateExcelFireReceiverMdb = async (requestBody) => {
  const response = await axiosInstance.post(
    `/dbms_main/fire-receiver-mdb/excel-validate/`,
    requestBody,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//화재수신기 MDB 엑셀 업로드
export const uploadExcelFireReceiverMdb = async (requestBody) => {
  const response = await axiosInstance.post(
    `/dbms_main/fire-receiver-mdb/excel-upload/`,
    requestBody,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return parseResult(response);
};

//화재수신기 MDB 다중 삭제
export const bulkDeleteFireReceiverMdb = async (requestBody) => {
  const response = await axiosInstance.delete(
    `/dbms_main/fire-receiver-mdb/bulk-delete/`,
    {
      data: requestBody,
      headers: { "Content-Type": "application/json" },
    }
  );
  return parseResult(response);
};
